import { createContext, type Ref, useContext } from 'react';
import { type useTopBarState } from './useTopBarState';

export type TopBarState = ReturnType<typeof useTopBarState> & { topBarRef: Ref<HTMLDivElement> };

export const TopBarStateContext = createContext<TopBarState | null>(null);

export const useTopBarContext = (): TopBarState => {
    const state = useContext(TopBarStateContext);

    if (!state) {
        throw new Error('TopBar requires TopBarLayoutWrapper');
    }

    return state;
};
